module.exports = __webpack_public_path__ + "static/media/undraw_push_notifications_im0o.52980e7b.png";